/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import {
    array, bool, func, object, string,
} from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import { MenuItem } from '@material-ui/core';

import { useDispatch } from 'react-redux';
import ErrorMessage from '../ErrorMessage/ErrorMessage';

import { getCountryDetailsByThreeDigitCountryCode } from '../../../../../../../state/ducks/Checkout/helpers/countryCode';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = (theme) => ({
    modalBox: {
        margin: '10px !important',
        maxHeight: '690px',
        minHeight: '428px',
        maxWidth: '574px',
        width: 'auto',
        minWidth: '460px',
        [theme.breakpoints.down('sm')]: {
            minWidth: '320px',
            maxWidth: '375px',
            maxHeight: '690px',
            minHeight: '474px',
        },
        '@media (max-height: 603px)': {
            maxHeight: 'initial',
            minHeight: 'initial',
            height: 'calc(100vh - 60px)',
        },
    },
    header: {
        borderBottom: 'solid 1px rgba(47, 47, 47, 0.15)',
        textTransform: 'uppercase',
        fontSize: '1em',
        fontWeight: '600',
        padding: '0',
        textAlign: 'center',
        margin: '0',
    },
    formControl: {
        minWidth: '100%',
    },
    menuContainer: {
        height: '200px',
    },
    title: {
        margin: 0,
        padding: '13px 0',
    },
    closeQAS: {
        border: 0,
        margin: 0,
        padding: '10px 5px',
        backgroundColor: 'white',
        boxShadow: 'none',
        color: 'black',
        '&:hover, &:focus, &:active, &:visited': {
            backgroundColor: 'white',
            color: 'black',
            boxShadow: 'none',
        },
    },
    dialogContent: {
        overflowY: 'auto',
        padding: '24px 25px 10px',
        margin: '0',
        '@media (max-height: 690px)': {
            padding: '15px 25px 0',
        },
        '@media (max-height: 603px)': {
            overflowY: 'scroll !important',
            overflow: '-moz-scrollbars-vertical',
            '&::-webkit-scrollbar': {
                '-moz-appearance': 'none',
                '-webkit-appearance': 'none',
                background: '#C4C4C4',
                width: '8px',
            },

            '&::-webkit-scrollbar-thumb': {
                borderRadius: '4px',
                backgroundColor: '#7B7B7B',
            },
        },
    },
    textInfo: {
        fontSize: '0.9em',
        lineHeight: '1.1em',
        fontWeight: 'normal',
    },
    shipToAddress: {
        margin: '16px 0px 14px',
    },
    address: {
        fontSize: '0.9em',
        fontWeight: '500',
        color: '#555555',
        lineHeight: '1.6em',
        margin: '0',
    },
    editAddressQas: {
        backgroundColor: 'white',
        border: 0,
        boxShadow: 'none',
        color: `${theme.palette.primary?.main}`,
        display: 'block',
        fontWeight: 'bold',
        padding: '0',
        margin: '16px 0 0',
        textAlign: 'right',
        textDecoration: 'underline',
        textTransform: 'none',
        width: '100%',
        '&:hover, &:focus, &:active, &:visited': {
            backgroundColor: 'white',
            color: `${theme.palette.primary?.main}`,
            boxShadow: 'none',
        },
    },
    qasShipAddress: {
        border: `1px solid ${theme.palette.common?.grey}`,
        borderRadius: '4px',
        margin: '16px 0',
        padding: '0 16px',
        cursor: 'pointer',
    },
    qasShipAddressSelected: {
        border: `3px solid ${theme.palette.primary?.main}`,
    },
    saveBtn: {
        backgroundColor: theme.palette.primary?.main,
        border: 0,
        borderRadius: '4px',
        color: theme.palette.primary?.contrastText,
        fontSize: '1em',
        fontWeight: 'bold',
        margin: '14px 0',
        padding: '14px 28px',
        textAlign: 'center',
        textTransform: 'none',
        width: '100%',
        boxShadow: 'none',
        '&:hover, &:focus, &:active, &:visited': {
            backgroundColor: theme.palette.primary?.main,
            color: theme.palette.primary?.contrastText,
        },
    },
    suggestionListRoot: {
        margin: '11px 0 10px 0',
        padding: '5px 0',
    },
    suggestionListContainer: {
        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.20);',
        borderRadius: '3px',
        backgroundColor: 'white',
        height: '256px',
        overflowY: 'scroll !important',
        overflow: '-moz-scrollbars-vertical',
        '&::-webkit-scrollbar': {
            '-moz-appearance': 'none',
            '-webkit-appearance': 'none',
            background: '#C4C4C4',
            width: '8px',
        },

        '&::-webkit-scrollbar-thumb': {
            borderRadius: '4px',
            backgroundColor: '#7B7B7B',
            boxShadow: '0 0 1px #7B7B7B',
        },
        '@media (max-height: 690px)': {
            height: '193px',
        },
        '@media (max-height: 670px)': {
            height: '129px',
        },
    },
    suggestionListContNoScroll: {
        borderRadius: '3px',
        backgroundColor: 'white',
        boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.20);',
        maxHeight: '256px',
    },
    titleSuggestionList: {
        borderTop: '1px solid #C4C4C4',
        padding: '16px 0 0',
        fontSize: '0.9em',
    },
    resultInfo: {
        color: '#555555',
        textAlign: 'right',
    },
    addressMenuItem: {
        backgroundColor: 'white',
        fontSize: '1em',
        padding: '11px 12px',
        width: '100%',
        '&:hover, &:focus, &:active, &:visited': {
            backgroundColor: '#E9E9E9',
        },
    },
    addressMenuSelected: {
        backgroundColor: '#E9E9E9',
        fontSize: '1em',
        padding: '11px 12px',
        width: '100%',
        '&:hover, &:focus, &:active, &:visited': {
            backgroundColor: '#E9E9E9',
        },
    },
    addressPrimaryLine: {
        fontSize: '1em',
        color: 'black',
        display: 'block',
    },
    addressSecondaryLine: {
        fontSize: '0.84em',
        fontWeight: '500',
        color: '#434343',
        lineHeight: '1.4em',
        margin: '0',
        display: 'block',
    },
});

const QASAddressContainer = ({
    addressItemPosition,
    addressSelected,
    classes,
    editVerificationQAS,
    handleKeepCurrentAddress,
    handleSelectedAddress,
    orderItemError,
    recipientQASData,
    saveVerificationQAS,
    showAddressValidation,
    suggestionList,
    typeData,
    versionQAS,
}) => {
    const dispatchAction = useDispatch();

    useEffect(() => {
        dispatchAction(trackEvent({
            eventCategory: 'Experiment',
            eventAction: 'QAS Modal UI Update',
            eventLabel: 'Control',
        }));

        if (suggestionList.length === 1) {
            dispatchAction(trackEvent({
                eventCategory: 'Checkout',
                eventAction: 'QAS Modal',
                eventLabel: 'Control - One suggestion',
            }));
        } else if (suggestionList.length > 1) {
            dispatchAction(trackEvent({
                eventCategory: 'Checkout',
                eventAction: 'QAS Modal',
                eventLabel: 'Control - Multiple suggestions',
            }));
        } else {
            dispatchAction(trackEvent({
                eventCategory: 'Checkout',
                eventAction: 'QAS Modal',
                eventLabel: 'Control - No suggestions',
            }));
        }
    }, []);

    const getOneSuggestion = () => {
        if (suggestionList.length === 1) {
            let addressInfo = suggestionList[0]?.[addressItemPosition];
            const positionComma = addressInfo.indexOf(',');
            addressInfo = [addressInfo.slice(0, positionComma), addressInfo.slice(positionComma + 1)];

            return (
                <Grid
                    container
                    className={`${classes.qasShipAddress} ${addressSelected.index !== null ? classes.qasShipAddressSelected : ''}`}
                    onClick={() => handleSelectedAddress(suggestionList[0], 0)}
                >
                    <Grid item xs={12}>
                        <Grid container className={classes.shipToAddress}>
                            <Grid item xs={12}>
                                <strong>We Suggest:</strong>
                            </Grid>
                            <Grid item xs={12}>
                                <p className={classes.address} align="left">
                                    {addressInfo[0]}
                                    <br />
                                    {addressInfo[1]}
                                </p>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            );
        }
        return null;
    };

    const getSuggestionList = () => {
        if (suggestionList.length > 0) {
            return (
                <Grid container className={classes.suggestionListRoot}>
                    <Grid item xs={12} className={suggestionList?.length < 5 ? classes.suggestionListContNoScroll : classes.suggestionListContainer} tabIndex={0}>
                        {
                            suggestionList.map((address, index) => {
                                let addressInfo = address[addressItemPosition];
                                const positionComma = addressInfo.indexOf(',');
                                addressInfo = [addressInfo.slice(0, positionComma), addressInfo.slice(positionComma + 1)];

                                return (
                                    <MenuItem
                                        value={index}
                                        className={addressSelected.index === index ? classes.addressMenuSelected : classes.addressMenuItem}
                                        key={addressInfo}
                                        onClick={() => handleSelectedAddress(address, index)}
                                        tabIndex={0}
                                    >
                                        <Grid container>
                                            <Grid item xs={12} className={classes.addressPrimaryLine}>{addressInfo[0]}</Grid>
                                            <Grid item xs={12} className={classes.addressSecondaryLine}>{addressInfo[1]}</Grid>
                                        </Grid>
                                    </MenuItem>
                                );
                            })
                        }
                    </Grid>
                </Grid>
            );
        }
        return null;
    };

    const shipToAddress = () => {
        let isPoBox = false;
        let PoBoxAddressLine1 = '';

        if (recipientQASData?.locationType?.includes('P.O.Box') && recipientQASData?.address1) {
            isPoBox = true;
            const extraPoboxText = recipientQASData.address1.slice(7, 13).toLowerCase();
            const defaultPoboxText = recipientQASData.address1.slice(0, 6).toLowerCase();
            if (((/(po)(\s|box)+/g).test(extraPoboxText))) {
                PoBoxAddressLine1 = recipientQASData.address1.replace('PO Box', '').trim();
            } else if (!(/(po)(\s|box)+/g).test(defaultPoboxText)) {
                PoBoxAddressLine1 = `PO Box ${recipientQASData.address1}`;
            } else {
                PoBoxAddressLine1 = recipientQASData.address1;
            }
        }

        let country = recipientQASData.country;
        if (country?.length === 3) {
            const countryObj = getCountryDetailsByThreeDigitCountryCode(country);
            country = countryObj.countryCodeTwoDigit;
        }

        return (
            <Grid
                id="suggested-address"
                container
                className={`${classes.qasShipAddress} ${addressSelected.index === null ? classes.qasShipAddressSelected : ''}`}
                onClick={handleKeepCurrentAddress}
                tabIndex={0}
            >
                <Grid item xs={12}>
                    <Grid container className={classes.shipToAddress}>
                        <Grid item xs={12}>
                            <strong>You Entered:</strong>
                        </Grid>
                        <Grid item xs={12}>
                            <p className={classes.address} align="left">
                                {
                                    isPoBox
                                        ? PoBoxAddressLine1
                                        : recipientQASData.address1
                                }
                                {
                                    recipientQASData.address2?.trim()
                                        ? <><br />{recipientQASData.address2}</>
                                        : null
                                }
                                {<><br />{recipientQASData.city}, {recipientQASData.state} {recipientQASData.zipCode}, {country}</>}
                            </p>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    return (
        <Dialog
            id={`DialogNewQASAddress${typeData}-${versionQAS}`}
            classes={{
                paper: classes.modalBox,
            }}
            open={showAddressValidation}
            data-testid={`DialogQASAddress${typeData}`}
        >
            <Grid container className={classes.header}>
                <Grid item xs={2}>&nbsp;</Grid>
                <Grid item xs={8}>
                    <p className={classes.title}>Verify Address</p>
                </Grid>
                <Grid item xs={2}>
                    <Grid container justifyContent="flex-end">
                        <Button
                            id="close-new-qas"
                            name="close-qas"
                            variant="contained"
                            color="primary"
                            data-test="checkout-recipient-address-edit"
                            className={classes.closeQAS}
                            onClick={() => editVerificationQAS()}
                            tabIndex={0}
                        >
                            X
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <Grid className={classes.dialogContent}>
                {orderItemError ? (
                    <ErrorMessage
                        noShadow
                        error={orderItemError}
                    />
                ) : null}
                <Grid container className={classes.textInfo}>
                    {'We couldn\'t verify your address, which may result in a delayed or lost delivery.'}
                    <br /><br />
                    Verify your address below:
                </Grid>
                {shipToAddress()}
                {
                    suggestionList.length > 0
                        ? (
                            <Grid id="new-qas-list" container>
                                {
                                    suggestionList.length === 1
                                        ? getOneSuggestion()
                                        : (
                                            <Grid container>
                                                <Grid className={classes.titleSuggestionList} item xs={12}>
                                                    <Grid container>
                                                        <Grid item xs={8} md={8}>
                                                            We recommend an address below:
                                                        </Grid>
                                                        <Grid className={classes.resultInfo} item xs={4} md={4}>
                                                            {suggestionList.length} results
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Grid container>
                                                        {getSuggestionList()}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )
                                }
                            </Grid>
                        ) : null
                }
                <Grid container>
                    <Grid item xs={12} md={12} lg={12}>
                        <Button
                            id="save-address-qas"
                            name="save-address-qas"
                            variant="contained"
                            className={classes.saveBtn}
                            data-test="checkout-recipient-address-save"
                            onClick={() => saveVerificationQAS()}
                            tabIndex={0}
                        >
                            Save & Continue
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
        </Dialog>
    );
};

QASAddressContainer.propTypes = {
    addressItemPosition: string.isRequired,
    addressSelected: object.isRequired,
    classes: object.isRequired,
    editVerificationQAS: func.isRequired,
    handleKeepCurrentAddress: func.isRequired,
    handleSelectedAddress: func.isRequired,
    orderItemError: string,
    recipientQASData: object.isRequired,
    saveVerificationQAS: func.isRequired,
    showAddressValidation: bool.isRequired,
    suggestionList: array.isRequired,
    typeData: string,
    versionQAS: string.isRequired,
};

QASAddressContainer.defaultProps = {
    typeData: '',
    orderItemError: null,
};
export default withStyles(styles)(QASAddressContainer);
